import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  console.log(STORE_KEY, INITIAL_STATE)
  const appState = state || redux.store.getState();
  console.log(appState?.[STORE_KEY] || INITIAL_STATE)
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectCustomerData = state => selectState(state).data;
export const selectedProduct = state => selectState(state).product;
export const getPrinters = state => selectState(state).printersdata;
export const selectCustomerLoading = state => selectState(state).loading;
export const selectfetchCustomerLoading = state => selectState(state).customerLoading;
export const selectCustomerError = state => selectState(state).error;
export const selectCustomerFilterVisible = state => selectState(state).filterVisible;
export const selectCustomerFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectLabelsList = state => selectState(state).labelsList;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredCustomers = createSelector(
  [selectCustomerData, selectCustomerFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);


